module.exports = __webpack_public_path__ + "img/awl.09b22062.svg";